/* eslint-disable no-undef */
import React from 'react';
import { connect } from 'react-redux';

import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import { Link } from 'react-router-dom';

import AuthCheckWrapper from '../../modules/AuthCheckWrapper';

const AuthenticationTestPage = connect((state) => ({ user: state.user }))(({ message }) => {
  return (
    <div className="AuthenticationTestPage">
      {__DEV__ && (
        <Container>
          <Text type="h1">
            <h1>renter-hub-web</h1>
          </Text>
          <Text type="h2">
            <h2>{message}</h2>
          </Text>
          <Text>This page is not visible on production.</Text>
          <ul>
            <li>
              <Link to="/renter-hub/authenticated-test">to authed page</Link>
            </li>
            <li>
              <Link to="/renter-hub/unauthenticated-test">to non-authed page</Link>
            </li>
            <li>
              <Link to="/renter-hub/strongauthenticated-test">to strong-authed page</Link>
            </li>
          </ul>
        </Container>
      )}
    </div>
  );
});

const AuthenticatedTestPage = () => {
  return (
    <AuthCheckWrapper>
      <AuthenticationTestPage message="Viewable only if authenticated." />
    </AuthCheckWrapper>
  );
};

const StrongAuthenticatedTestPage = () => {
  return (
    <AuthCheckWrapper requireStrongAuthentication>
      <AuthenticationTestPage message="Viewable only if STRONGLY authenticated." />
    </AuthCheckWrapper>
  );
};

const UnauthenticatedTestPage = () => {
  return <AuthenticationTestPage message="Viewable regardless of authentication state." />;
};

export { AuthenticatedTestPage, UnauthenticatedTestPage, StrongAuthenticatedTestPage };
